import { render, staticRenderFns } from "./PixFirstTransaction.vue?vue&type=template&id=f73347aa"
import script from "./PixFirstTransaction.vue?vue&type=script&lang=js"
export * from "./PixFirstTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports